{
  "name": "painel",
  "version": "1.39.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port=7200 --open ",
    "build": "ng build --configuration=production --aot=true --optimization=true",
    "build:stag": "ng build --configuration=stag --aot=true --optimization=true",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "sonar": "sonar-scanner",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org mar-saude --project patient ./dist/patient && sentry-cli sourcemaps upload --org mar-saude --project patient ./dist/patient",
    "changelog-version": "node generate-changelog-update-version.js",
    "commit-version": "git add . && git commit -m'Version name: '$(grep -m1 version package.json | awk -F: '{ print $2 }' | sed 's/[\", ]//g')''",
    "update-angular": "ng update @angular/core @angular/cli @angular/cdk @angular-devkit/build-angular @angular/compiler-cli @angular/material",
    "release": "npm run changelog-version && npm run commit-version && git push && git checkout main && git pull && git merge --no-ff --no-edit dev && git push && git checkout -"
  },
  "browser": {
    "fs": false,
    "path": false,
    "os": false
  },
  "private": true,
  "dependencies": {
    "@ag-grid-community/locale": "^33.2.3",
    "@amplitude/analytics-browser": "^2.34.0",
    "@amplitude/plugin-page-url-enrichment-browser": "^0.5.15",
    "@angular/animations": "21.2.17",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.17",
    "@angular/compiler": "21.2.17",
    "@angular/core": "21.2.17",
    "@angular/forms": "21.2.17",
    "@angular/material": "21.2.14",
    "@angular/material-moment-adapter": "21.2.14",
    "@angular/platform-browser": "21.2.17",
    "@angular/platform-browser-dynamic": "21.2.17",
    "@angular/router": "21.2.17",
    "@ngx-formly/core": "^6.3.12",
    "@ngx-formly/material": "^6.3.12",
    "@sentry/angular": "^10.44.0",
    "@sentry/cli": "^2.45.0",
    "ag-grid-angular": "^33.2.1",
    "ag-grid-community": "^33.2.1",
    "canvg": "^4.0.3",
    "chart.js": "^4.5.0",
    "chartjs-plugin-annotation": "^3.1.0",
    "chartjs-plugin-datalabels": "^2.2.0",
    "core-js": "^3.49.0",
    "d3": "^7.9.0",
    "dayjs": "^1.11.19",
    "flatpickr": "^4.6.13",
    "html2canvas": "^1.4.1",
    "iframe-resizer": "^5.5.9",
    "jspdf": "^4.2.1",
    "lodash": "^4.18.1",
    "material-symbols": "^0.36.2",
    "modern-screenshot": "^4.7.0",
    "ng2-charts": "^8.0.0",
    "ng2-currency-mask": "^13.0.3",
    "ngx-file-drop": "^16.0.0",
    "ngx-mask": "^17.0.7",
    "numeral": "^2.0.6",
    "rxjs": "~7.8.0",
    "tslib": "^2.6.3",
    "zone.js": "~0.15.0",
    "zstd-codec": "^0.1.5"
  },
  "devDependencies": {
    "@angular/build": "21.2.17",
    "@angular/cli": "21.2.17",
    "@angular/compiler-cli": "21.2.17",
    "@types/jasmine": "~5.1.5",
    "@types/numeral": "^2.0.5",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "semver": "^7.7.4",
    "sonar-scanner": "^3.1.0",
    "tmp": "0.2.7",
    "typescript": "~5.9.3"
  },
  "overrides": {
    "express-rate-limit": {
      "ip-address": "10.1.1"
    },
    "karma": {
      "socket.io": "4.8.3",
      "tmp": "0.2.7"
    },
    "anymatch": {
      "picomatch": "2.3.2"
    },
    "readdirp": {
      "picomatch": "2.3.2"
    },
    "undici": "7.28.0"
  }
}